export const energyCostCalculatorToolState = {
  energy: {
    howMuch: null, // How much do you pay monthly for energy?
    multiplier: null, // from Glide optionsJson
  },
}
